<template>
  <div>
    <b-col class="zone-main-title">
      <h1 class="main-title">
        Libraires
        <span class="separator" />
      </h1>
    </b-col>
    <ListeLibraires />
  </div>
</template>

<script>
import ListeLibraires from "@/components/libraires/ListeLibraires.vue";

export default {
  name: "Libraires",
  components: {
    ListeLibraires,
  },
};
</script>

<style lang="scss" scoped></style>
